//import DispatcherStream from 'dispatcher-stream'
import {Writable} from 'stream'
import MapStream from 'pw-map-stream'

class WorkerStreamSubscriber {
  constructor({uiToWorkerDataStream, workerToUiDataSink, streamingClient, workerGraphs}) {
    this.uiToWorkerDataStream = uiToWorkerDataStream
    this.workerToUiDataSink = workerToUiDataSink
    this.workerGraphs = workerGraphs
    this.streamingClient = streamingClient
    this.streams = new Map()

    this.actionHandler = Writable({objectMode: true, write: (data, enc, next) => {
      if (data.action === 'create') {
        this.create(data.message, {pipeToUi: true})
      } else if (data.action === 'update') {
        this.updateStream(data.name, data.options)
      } else if (data.action === 'destroy') {
        this.destroyStream(data.name)
      }
      next()
    }})
    this.uiToWorkerDataStream.pipe(this.actionHandler)
  }

  create(message, options) {
    const pipeToUi = options && options.pipeToUi
    const name = message.name
    if (this.streams.has(name)) { throw new Error("Duplicate stream name")}
    const stream = this.streamingClient.create(message)
    const GraphConstructor = this.workerGraphs.getConstructor(message.path)
    this.streams.set(name, stream)
    const graphStream = stream.pipe(GraphConstructor(message.options))
    if (pipeToUi) {
      const streamToPipe = (graphStream.output && typeof graphStream.output === 'function') ?
        graphStream.output : graphStream
      streamToPipe.
        pipe(MapStream(data => ({action: 'data', name, data}))).
        pipe(this.workerToUiDataSink, {end: false})

      const dataSink = this.workerToUiDataSink
      const emit0 = stream.emitEvent.bind(stream)
      stream.emitEvent = function (event) {
        dataSink.write({action: 'event', name, eventName: event.name, eventData: event.data})
        emit0(event)
      }
    }

    graphStream.destroy = () => this.destroyStream(name)
    graphStream.update = (_options) => this.updateStream(name, _options)
    graphStream.once('end', () => this.notifyStreamEnd(name))
    return graphStream
  }

  destroyStream(name) {
    const stream = this.streams.get(name)
    if (!stream) { return }
    this.streams.delete(name)
    stream.destroy()
  }

  updateStream(name, options) {
    const stream = this.streams.get(name)
    if (!stream) { return }
    stream.update(options)
  }

  notifyStreamEnd(name) {
    this.workerToUiDataSink.write({action: 'end', name})
  }

  sendEvent(name, eventName, eventData) {
    this.workerToUiDataSink.write({action: 'event', name, eventName, eventData})
  }
}

export default WorkerStreamSubscriber
